import React from "react";
import axios from '../../axios/axiosconf'
import { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../general/Loading";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ModalResumenRemision from "./ModalResumenRemision";
import { formatFecha } from "../../../resources/Helper";
import SignatureCanvas from 'react-signature-canvas';
import html2pdf from "html2pdf-fix-jspdf";

function ModalConsentimientos(props) {

    const queryParams = useLocation().search;
    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(true);
    const [client, setClient] = useState([]);

    const paciente_id = new URLSearchParams(queryParams).get('id');

    const [pacienteId, setPacienteId] = useState(new URLSearchParams(queryParams).get('id'));

    
    const [contenido, setContenido] = useState('');

    const [nombreProfesional, setNombreProfesional] = useState('');
    const [registroMedico, setRegistroMedico] = useState('');
    const [codigoHabilitacion, setCodigoHabilitacion] = useState('');
    const [firmaimg, setFirmaimg] = useState('');

    const [historial, setHistorial] = useState([]);
    const [plantillas, setPlantillas] = useState([]);

    const [errorlist, setErrorlist] = useState({});

    const [tituloResumen, setTituloResumen] = useState();
    const [contenidoResumenIndividual, setContenidoResumenIndividual] = useState();
    const [profesionalResumenIndividual, setProfesionalResumenIndividual] = useState();
    const [registroMedicoResumenIndividual, setRegistroMedicoResumenIndividual] = useState();
    const [codigoHabilitacionResumenIndividual, setCodigoHabilitacionResumenIndividual] = useState();
    const [firmaResumenIndividual, setFirmaResumenIndividual] = useState();

    const [consolidado, setConsolidado] = useState('');

    /** Registro del historial cargado en el formulario (evolución: ver en editor antes de PDF) */
    const [consentimientoSeleccionado, setConsentimientoSeleccionado] = useState(null);
    const [modoVisualizacionHistorico, setModoVisualizacionHistorico] = useState(false);

    // Estados para controlar modales con React (como en ModalContraremisiones.js)
    const [showModalResumen, setShowModalResumen] = useState(false);
    const [showModalConsolidado, setShowModalConsolidado] = useState(false);
    /** Config para jsPDF nativo (misma vía que evolución); la vista previa del modal sigue en HTML */
    const [pdfNativoConfigConsentimiento, setPdfNativoConfigConsentimiento] = useState(null);

    const canvasRef = useRef(null);
    const [editorConsentimiento, setEditorConsentimiento] = useState(null);

    let history = useHistory();
    let userdata = [];
    const logoImg = '/smile/dist/img/logo-2.png';
    const [deshabilitarBotonGuardar, setDeshabilitarBotonGuardar] = useState(false);

    useEffect(() => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }
        
        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: userdata.user_id
            }
        }

        axios.get('/get-client', config)
            .then(response => {
                if (response.status===200) {
                    setClient(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            });
        
        axios.get('/perfil', config)
            .then(response => {
                if (response.status===200) {
                    
                    setNombreProfesional(response.data.name+' '+response.data.lastname);
                    setRegistroMedico(response.data.registro_medico);
                    setCodigoHabilitacion(response.data.codigo_habilitacion);
                    setFirmaimg(response.data.firma_blob);
                }
            })
            .catch(error => {
                console.log(error);
            });
        
        axios.get('/plantillas-consentimientos', config)
            .then(response => {
                setPlantillas(response.data);
            })
            .catch(error => {
                console.log(error);
            });
        
    },[]);


    const cargaritems = () => {
        
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Verificar si debe validar acceso
        const esProfesionalIndependiente = userdata.permissions && 
            userdata.permissions.some(permission => permission.slug === 'profesionalIndependiente');

        const config2 = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: userdata.user_id,
                id: paciente_id
            }
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Agregar parámetro de validación si es necesario
        if (esProfesionalIndependiente) {
            config2.params.validar_asignacion = true;
        }

        console.log('DEBUG Frontend - Enviando request con params:', JSON.stringify(config2.params)); // ✅ DEBUG mejorado

        axios.get('/consentimientos', config2)
            .then(response => {
                console.log('Consentimientos Cargados:', response.data);
                setHistorial(response.data);

                let consolidadoItems = "";

                response.data.map((item) => {

                    // 🎨 FORMATO TABLA CON BANDAS GRISES

                    // 1. Tabla de información básica (Fecha)
                    let segmentoCabecera = `
                        <div style="margin-bottom: 12px;">
                            <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                                <tbody>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 30%; border: 1px solid #dee2e6;">FECHA Y HORA</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${item.fecha}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>`;

                    // 2. Tabla de contenido del consentimiento
                    let segmentoContenido = '';
                    if (item.contenido) {
                        segmentoContenido = `
                            <div style="margin-bottom: 12px;">
                                <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                                    <tbody>
                                        <tr>
                                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">CONSENTIMIENTO INFORMADO</td>
                                        </tr>
                                        <tr>
                                            <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6;">
                                                ${item.contenido}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>`;
                    }

                    // 3. Tabla de firma del paciente
                    let segmentoFirmaPaciente = '';
                    if (item.firma_paciente) {
                        segmentoFirmaPaciente = `
                            <div style="margin-bottom: 12px;">
                                <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                                    <tbody>
                                        <tr>
                                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 35%; border: 1px solid #dee2e6;">FIRMA DEL PACIENTE</td>
                                            <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6;">
                                                <img src="${item.firma_paciente}" style="max-width: 180px; max-height: 90px; display: block;" />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>`;
                    }

                    // 4. Tabla de profesional que atiende
                    let segmentoProfesional = `
                        <div style="margin-bottom: 12px;">
                            <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                                <tbody>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 35%; border: 1px solid #dee2e6;">PROFESIONAL QUE ATIENDE</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6; font-weight: bold; color: #325e68;">${item.profesional}</td>
                                    </tr>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">REGISTRO MÉDICO</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${item.registro_medico || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">CÓDIGO DE HABILITACIÓN</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${item.codigo_habilitacion || 'N/A'}</td>
                                    </tr>`;

                    if (item.firma) {
                        segmentoProfesional += `
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">FIRMA DEL PROFESIONAL</td>
                                        <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6;">
                                            <img src="${item.firma}" style="max-width: 180px; max-height: 90px; display: block;" />
                                        </td>
                                    </tr>`;
                    }

                    segmentoProfesional += `
                                </tbody>
                            </table>
                        </div>`;

                    // 5. Separador entre consentimientos
                    let separadorConsentimientos = `<hr style="border-top: 2px solid #e0e0e0; margin: 25px 0;">`;

                    const itemParcial = segmentoCabecera + segmentoContenido + segmentoFirmaPaciente + segmentoProfesional + separadorConsentimientos;

                    consolidadoItems += itemParcial;
                    return null;
                });

                setConsolidado(consolidadoItems);
            })
            .catch(error => {
                console.log(error);
            })
    }



    const contenidoHandler = (event, editor) => {
        if (modoVisualizacionHistorico) return;
        setContenido(editor.getData());
    };
    



    const handleSubmit = (e) => {
        
        e.preventDefault();

        if (modoVisualizacionHistorico) {
            return;
        }

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Verificar si debe validar acceso
        const esProfesionalIndependiente = userdata.permissions && 
            userdata.permissions.some(permission => permission.slug === 'profesionalIndependiente');

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        const data = {
            paciente_id: pacienteId,
            client_id: client.client_id,
            profesional: nombreProfesional, 
            firma: firmaimg || '', // ✅ MEJORADO: Si firmaimg es null, usar string vacío
            registro_medico: registroMedico,
            codigo_habilitacion: codigoHabilitacion,
            contenido: contenido,
            firma_paciente: ''
        };

        // 🆕 PROFESIONAL INDEPENDIENTE - Agregar parámetro de validación si es necesario
        if (esProfesionalIndependiente) {
            data.validar_asignacion = true;
        }

        if (canvasRef.current && !canvasRef.current.isEmpty()) {
            data.firma_paciente = canvasRef.current.toDataURL('image/png');
        }
        
        axios.post('/consentimiento', data, config)
            .then(response => {
                setLoading(false);
                setDeshabilitarBotonGuardar(false); // ✅ CORREGIDO: Rehabilitar botón después de guardar
                props.guardarCambios('El Consentimiento Informado Ha Sido Guardado con Exito en la Historia del Paciente');
                
                // ✅ CORREGIDO: Limpiar formulario después de guardar exitosamente
                setConsentimientoSeleccionado(null);
                setModoVisualizacionHistorico(false);
                setContenido('');
                if (canvasRef.current) {
                    canvasRef.current.clear();
                }
                const sel = document.getElementById('plantillas');
                if (sel) sel.value = '';
                
                // ✅ CORREGIDO: Recargar historial inmediatamente
                cargaritems();
            })
            .catch(error => {
                setLoading(false);
                console.log('Error Guardando el Consentimiento, Intenta Nuevamente:', error);
                if (error.response && error.response.data && error.response.data.errors) {
                    setErrorlist(error.response.data.errors);
                } else {
                    setErrorlist({});
                }
            })
            
    }


    /** HTML único para modal/PDF (misma fuente que los datos mostrados en el formulario cuando aplica) */
    const construirHtmlResumenConsentimiento = (resumenIndividual) => {
        const nombreCompleto = props.paciente ?
            `${props.paciente.primerNombre || ''} ${props.paciente.segundoNombre || ''} ${props.paciente.primerApellido || ''} ${props.paciente.segundoApellido || ''}`.trim() :
            'Paciente No Identificado';

        const documentoCompleto = props.paciente ?
            `${props.paciente.tipoDocumento || ''} - ${props.paciente.numeroDocumento || ''}` :
            'Documento No Disponible';

        let banner = `
            <div style="margin-bottom: 12px;">
                <div style="background-color: #e9ecef; padding: 8px 12px; font-weight: bold; font-size: 14px; border-radius: 4px; text-align: center; border: 1px solid #dee2e6;">
                    CONSENTIMIENTO INFORMADO
                </div>
            </div>`;

        let tablaInfoPaciente = `
            <div style="margin-bottom: 12px;">
                <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                    <tbody>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 25%; border: 1px solid #dee2e6;">FECHA Y HORA</td>
                            <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${resumenIndividual.fecha}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">PACIENTE</td>
                            <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${nombreCompleto}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">DOCUMENTO</td>
                            <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${documentoCompleto}</td>
                        </tr>
                    </tbody>
                </table>
            </div>`;

        let tablaContenido = `
            <div style="margin-bottom: 12px; page-break-inside: avoid;">
                <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                    <tbody>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">DESCRIPCIÓN</td>
                        </tr>
                        <tr>
                            <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6;">
                                ${resumenIndividual.contenido || 'Sin contenido especificado'}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>`;

        let tablaFirmaPaciente = '';
        if (resumenIndividual.firma_paciente) {
            tablaFirmaPaciente = `
                <div style="margin-bottom: 12px; page-break-inside: avoid;">
                    <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                        <tbody>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 35%; border: 1px solid #dee2e6;">FIRMA DEL PACIENTE</td>
                                <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6;">
                                    <img src="${resumenIndividual.firma_paciente}" style="max-width: 180px; max-height: 90px; display: block;" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>`;
        }

        let tablaProfesional = `
            <div style="margin-top: 16px; page-break-inside: avoid;">
                <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                    <tbody>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 35%; border: 1px solid #dee2e6;">PROFESIONAL QUE ATIENDE</td>
                            <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6; font-weight: bold; color: #325e68;">${resumenIndividual.profesional}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">REGISTRO MÉDICO</td>
                            <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${resumenIndividual.registro_medico || 'N/A'}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">CÓDIGO DE HABILITACIÓN</td>
                            <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${resumenIndividual.codigo_habilitacion || 'N/A'}</td>
                        </tr>`;

        if (resumenIndividual.firma) {
            tablaProfesional += `
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">FIRMA DEL PROFESIONAL</td>
                            <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6;">
                                <img src="${resumenIndividual.firma}" style="max-width: 180px; max-height: 90px; display: block;" />
                            </td>
                        </tr>`;
        }

        tablaProfesional += `
                    </tbody>
                </table>
            </div>`;

        return banner + tablaInfoPaciente + tablaContenido + tablaFirmaPaciente + tablaProfesional;
    };

    const obtenerDatosPacientePdf = () => {
        const p = props.paciente;
        if (!p) {
            return {
                nombreCompleto: 'Paciente no identificado',
                documentoCompleto: '—'
            };
        }
        const nombreCompleto = `${p.primerNombre || ''} ${p.segundoNombre || ''} ${p.primerApellido || ''} ${p.segundoApellido || ''}`.trim() || 'Paciente no identificado';
        const documentoCompleto = p.tipoDocumento && p.numeroDocumento
            ? `${p.tipoDocumento} - ${p.numeroDocumento}`
            : (p.numeroDocumento || '—');
        return { nombreCompleto, documentoCompleto };
    };

    /**
     * PDF con texto nativo (jsPDF + autotable), alineado con ModalEvolucion / generarPdfConTextoNativo.
     * Evita cortes raros del html2canvas. El bloque PACIENTE/DOCUMENTO lo inserta el helper.
     */
    const construirConfigPdfConsentimientoNativo = (payload) => {
        const { nombreCompleto, documentoCompleto } = obtenerDatosPacientePdf();
        const slug = props.docPaciente || props.paciente?.numeroDocumento || 'paciente';

        const config = {
            filename: `consentimiento-informado-${slug}.pdf`,
            paciente: {
                nombreCompleto,
                documentoCompleto
            },
            encabezadoPersonalizado: null,
            secciones: []
        };

        config.secciones.push({
            tipo: 'banner',
            titulo: 'CONSENTIMIENTO INFORMADO',
            contenido: 'CONSENTIMIENTO INFORMADO'
        });

        config.secciones.push({
            tipo: 'tabla-datos',
            datos: {
                filas: [
                    { etiqueta: 'FECHA Y HORA', valor: String(payload.fecha || '') }
                ]
            }
        });

        config.secciones.push({
            tipo: 'texto',
            titulo: 'DESCRIPCIÓN',
            contenido: payload.contenido || ''
        });

        const firmasGrupo = [];
        if (payload.firma) {
            firmasGrupo.push({
                imagenBase64: payload.firma,
                metadata: {
                    tipo: 'profesional',
                    nombre: payload.profesional || '',
                    registroMedico: payload.registro_medico || 'N/A',
                    codigoHabilitacion: payload.codigo_habilitacion || 'N/A'
                }
            });
        }
        if (payload.firma_paciente) {
            firmasGrupo.push({
                imagenBase64: payload.firma_paciente,
                metadata: { tipo: 'paciente' }
            });
        }
        if (firmasGrupo.length > 0) {
            config.secciones.push({
                tipo: 'firmas-grupo',
                firmas: firmasGrupo
            });
        }

        return config;
    };

    const cargarConsentimientoHistorico = (item) => {
        setConsentimientoSeleccionado(item);
        setModoVisualizacionHistorico(true);
        setContenido(item.contenido || '');
        setErrorlist({});

        setTimeout(() => {
            if (!canvasRef.current) return;
            canvasRef.current.clear();
            if (item.firma_paciente) {
                try {
                    canvasRef.current.fromDataURL(item.firma_paciente);
                } catch (err) {
                    console.warn('No se pudo cargar firma del paciente en canvas:', err);
                }
            }
        }, 150);
    };

    const nuevoConsentimiento = () => {
        setConsentimientoSeleccionado(null);
        setModoVisualizacionHistorico(false);
        setContenido('');
        setErrorlist({});
        if (canvasRef.current) {
            canvasRef.current.clear();
        }
        const sel = document.getElementById('plantillas');
        if (sel) sel.value = '';
    };

    /** Vista previa / PDF desde el estado actual del formulario (incluye borrador nuevo o registro histórico cargado) */
    const abrirVistaImpresionDesdeFormulario = () => {
        let fechaTexto;
        let payload;

        if (modoVisualizacionHistorico && consentimientoSeleccionado) {
            fechaTexto = consentimientoSeleccionado.fecha;
            payload = {
                fecha: fechaTexto,
                contenido: contenido,
                firma_paciente: consentimientoSeleccionado.firma_paciente || (canvasRef.current && !canvasRef.current.isEmpty() ? canvasRef.current.toDataURL('image/png') : ''),
                profesional: consentimientoSeleccionado.profesional,
                registro_medico: consentimientoSeleccionado.registro_medico,
                codigo_habilitacion: consentimientoSeleccionado.codigo_habilitacion,
                firma: consentimientoSeleccionado.firma
            };
        } else {
            const ahora = new Date();
            fechaTexto = ahora.toLocaleString();
            let firmaPac = '';
            if (canvasRef.current && !canvasRef.current.isEmpty()) {
                firmaPac = canvasRef.current.toDataURL('image/png');
            }
            payload = {
                fecha: fechaTexto,
                contenido: contenido,
                firma_paciente: firmaPac,
                profesional: nombreProfesional,
                registro_medico: registroMedico,
                codigo_habilitacion: codigoHabilitacion,
                firma: firmaimg
            };
        }

        setTituloResumen('Consentimiento Informado');
        setContenidoResumenIndividual(construirHtmlResumenConsentimiento(payload));
        setPdfNativoConfigConsentimiento(construirConfigPdfConsentimientoNativo(payload));
        setShowModalResumen(true);
    };

    
    useEffect(() => {
        cargaritems();
    },[props.cargarHistorial]);

    useEffect(() => {
        if (!editorConsentimiento) return;
        try {
            if (modoVisualizacionHistorico) {
                editorConsentimiento.enableReadOnlyMode('modal-consentimiento-hist');
            } else {
                editorConsentimiento.disableReadOnlyMode('modal-consentimiento-hist');
            }
        } catch (e) {
            console.warn('CKEditor readOnly:', e);
        }
    }, [modoVisualizacionHistorico, editorConsentimiento]);

    // ✅ AGREGADO: Cleanup cuando se cierran los modales (como en ModalContraremisiones.js)
    useEffect(() => {
        return () => {
            setShowModalResumen(false);
            setShowModalConsolidado(false);
        };
    }, []);


    const descargarPdf = () => {
        
        var opt = {
            margin:       12,
            filename:     `consentimientos.pdf`,
            image:        { type: 'jpeg', quality: 0.97 },
            html2canvas:  { scale: 2, useCORS: true, allowTaint: true },
            jsPDF:        { unit: 'mm', format: 'letter', orientation: 'portrait' }
        };

        let anamnesis = props.anamnesis();
        let consentimientosCompleto = "<img src='"+logoImg+"' class='app-logo-pdf' /><h1 class='ttl-pdf'>CONSENTIMIENTOS INFORMADOS</h1>"+anamnesis+"<div class='salto-pagina-pdf'></div>" + consolidado;

        html2pdf(consentimientosCompleto,opt);
    }


    const handleContenido = (contenidoPlantilla) => {

        let nombreCompletoPaciente = props.paciente.primerNombre + ' ' + (props.paciente.segundoNombre ? props.paciente.segundoNombre + ' ' : '') + props.paciente.primerApellido + ' ' + (props.paciente.segundoApellido ? props.paciente.segundoApellido : '');
        let fechaActual = new Date();

        contenidoPlantilla = contenidoPlantilla.replace("{{nombre}}",nombreCompletoPaciente);
        contenidoPlantilla = contenidoPlantilla.replace("{{numero_documento}}",props.paciente.numeroDocumento);
        contenidoPlantilla = contenidoPlantilla.replace("{{tipo_documento}}",props.paciente.tipoDocumento);
        contenidoPlantilla = contenidoPlantilla.replace("{{fecha}}",fechaActual.getDate()+'/'+(fechaActual.getMonth()+1)+'/'+fechaActual.getFullYear());

        setContenido(contenidoPlantilla);
    }


    if (loggedIn) {
        return (
            
                <>
                    <section className="content">
                        <div className="container-fluid">

                            <div className="row">
                                <div className="col-md-9">

                                    <form id="role-form" onSubmit={handleSubmit} autoComplete="off">

                                        <div className="d-flex flex-wrap align-items-center justify-content-between mb-3 pb-2 border-bottom">
                                            <div className="d-flex flex-wrap align-items-center mb-1 mb-md-0">
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-outline-secondary mr-2 mb-1"
                                                    onClick={abrirVistaImpresionDesdeFormulario}
                                                    title="Abrir vista previa e imprimir o descargar PDF"
                                                >
                                                    <i className="fas fa-file-pdf mr-1"></i> Vista previa / PDF
                                                </button>
                                                {modoVisualizacionHistorico && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-secondary mb-1"
                                                        onClick={nuevoConsentimiento}
                                                        title="Limpiar formulario para un consentimiento nuevo"
                                                    >
                                                        <i className="fas fa-plus mr-1"></i> Nuevo consentimiento
                                                    </button>
                                                )}
                                            </div>
                                        </div>

                                        {modoVisualizacionHistorico && consentimientoSeleccionado && (
                                            <div className="alert alert-secondary py-2 mb-3" role="status">
                                                <i className="fas fa-history mr-2"></i>
                                                Viendo consentimiento del <strong>{consentimientoSeleccionado.fecha}</strong>. Los botones de vista PDF e imprimir están en la ventana de vista previa.
                                            </div>
                                        )}

                                        <div id="historiageneral">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <label style={{fontSize:'0.85rem',marginBottom:'8px'}}>Seleccione La Plantilla o Digite Su Contenido</label>
                                                    

                                                    <div className="form-group">
                                                        <select name="plantillas" className="form-control" id="plantillas" disabled={modoVisualizacionHistorico} onChange={(e) => handleContenido(e.target.value)} >
                                                            <option value="">Seleccionar Plantilla...</option>
                                                            {
                                                                plantillas.map((plantilla) => 
                                                                    <option key={plantilla.id} value={plantilla.contenido}>{plantilla.titulo}</option>
                                                                )
                                                            }
                                                        </select>
                                                    </div>
                                                    <div className="form-group">
                                                        <CKEditor
                                                            editor={ClassicEditor}
                                                            onReady={(editor) => setEditorConsentimiento(editor)}
                                                            onChange={contenidoHandler}
                                                            data={contenido}
                                                        />
                                                    </div>
                                                    <div className="invalid-feedback visible">
                                                    {errorlist.contenido}
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <label>Firma del Paciente</label>
                                                    <div className="form-group" style={modoVisualizacionHistorico ? { pointerEvents: 'none', opacity: 0.95 } : undefined}>
                                                        <SignatureCanvas ref={canvasRef} penColor='#242424' canvasProps={{width: 300, height: 130, className: 'sigCanvas', style:{border:'1px solid #c4c4c4'}}} />
                                                        <br />
                                                        <button type="button" className="btn btn-primary btn-sm" disabled={modoVisualizacionHistorico} onClick={(e) => { e.preventDefault(); if (canvasRef.current) canvasRef.current.clear(); }}><i className="fas fa-eraser"></i> Borrar</button>&nbsp;
                                                    </div>
                                                    <div className="invalid-feedback visible">
                                                    {errorlist.firma_paciente}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="card">
                                            <div id="profesional-atiende">
                                                <div className="card-body" style={{padding: '0.7rem'}}>
                                                    <div className="row">
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="nombreProfesional">Profesional Que Atiende</label>
                                                                <br></br>
                                                                {modoVisualizacionHistorico && consentimientoSeleccionado ? consentimientoSeleccionado.profesional : nombreProfesional}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="nombreProfesional">Registro Médico</label>
                                                                <br></br>
                                                                {modoVisualizacionHistorico && consentimientoSeleccionado ? (consentimientoSeleccionado.registro_medico || 'N/A') : registroMedico}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="clasificacion_riesgo">Código De Habilitación</label>
                                                                <br></br>
                                                                {modoVisualizacionHistorico && consentimientoSeleccionado ? (consentimientoSeleccionado.codigo_habilitacion || 'N/A') : codigoHabilitacion}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group" style={{marginBottom: '0.4rem'}}>
                                                                <label htmlFor="nombreProfesional">Firma</label>
                                                                <br></br>
                                                                <img src={modoVisualizacionHistorico && consentimientoSeleccionado && consentimientoSeleccionado.firma ? consentimientoSeleccionado.firma : firmaimg} className="firma-profesional-hc" alt="" />
                                                            </div>
                                                        </div>  
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                            
                                        <div className="row">
                                            <div className="col-md-12 d-flex flex-wrap align-items-center">
                                                <button type="submit" className="btn btn-secondary mb-2 mb-sm-0 mr-2" disabled={deshabilitarBotonGuardar || modoVisualizacionHistorico}>
                                                    Guardar&nbsp;
                                                    {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                                                </button>
                                                <a href="#" className="btn btn-outline-secondary mb-2 mb-sm-0" onClick={(e) => { e.preventDefault(); props.cerrarModal(); }}>Cerrar</a>
                                            </div>
                                        </div>

                                        
                                    
                                    </form>
                                
        
                                </div>
                                <div className="col-md-3">
                                    
                                    
                                    
                                    <div className="timeline-evolucion">

                                        <b className="titulo-historial">Historial</b>

                                        {

                                            historial.map((item) => 
                                                
                                                    <div
                                                        key={item.id}
                                                        className="timeline-item-container"
                                                        onClick={() => cargarConsentimientoHistorico(item)}
                                                        style={{
                                                            cursor: 'pointer',
                                                            ...(consentimientoSeleccionado && consentimientoSeleccionado.id === item.id
                                                                ? { backgroundColor: 'rgba(23, 162, 184, 0.12)', borderRadius: '8px', padding: '4px 6px' }
                                                                : {})
                                                        }}
                                                    >
                                                        <div className="timeline-punto-container"><div className="timeline-punto" style={consentimientoSeleccionado && consentimientoSeleccionado.id === item.id ? { backgroundColor: '#17a2b8', borderColor: '#17a2b8' } : undefined}></div></div>
                                                        <div className="timeline-meta">{formatFecha(new Date(item.fecha))}</div>
                                                    </div>
                                                )
                                        }

                                    </div>

                                    <button className="btn btn-primary btn-resumen-historico" onClick={() => setShowModalConsolidado(true)}>Resumen</button>
                                    {/*<br />
                                    <button className="btn btn-primary btn-resumen-historico" onClick={descargarPdf}>Descargar</button>*/}

                                </div>
                            
                            </div>
                            
                        </div>
                    </section>

                {/* ✅ MODALES CON REACT STATE (como en ModalRemisiones.js) */}
                {showModalResumen && (
                    <ModalResumenRemision 
                        idModal="modalResumenConsentimientos"
                        titulo={tituloResumen} 
                        contenido={contenidoResumenIndividual} 
                        profesional={profesionalResumenIndividual} 
                        registro={registroMedicoResumenIndividual} 
                        codigo={codigoHabilitacionResumenIndividual} 
                        firma={firmaResumenIndividual}
                        paciente={props.paciente}
                        tipoArchivo={'consentimiento-informado'}
                        cliente={client}
                        docPaciente={props.docPaciente || props.paciente?.numeroDocumento}
                        incluirTituloPdf={false}
                        pdfAltoContraste={true}
                        pdfNativoConfig={pdfNativoConfigConsentimiento}
                        onClose={() => {
                            setShowModalResumen(false);
                            setPdfNativoConfigConsentimiento(null);
                        }}
                    />
                )}

                {showModalConsolidado && (
                    <ModalResumenRemision 
                        idModal="modalConsolidadoConsentimientos"
                        titulo="Resumen consentimientos informados" 
                        contenido={consolidado}
                        paciente={props.paciente}
                        tipoArchivo={'historico-consentimientos-informados'}
                        cliente={client}
                        pdfAltoContraste={true}
                        onClose={() => setShowModalConsolidado(false)}
                    />
                )}

                </>
                
            
        );
    }

    return (
        <Loading />
    );
}
export default ModalConsentimientos;